<div class="mx-auto w-75" *ngIf="messageDiv!=''">
    <span [innerHtml]="messageDiv"></span>
</div>
<!--REcibo nro. 1-->
<div media="print" class="{{setImpresion ? '':'noView'}} text-center"
    style="max-width:280px; font-family: 'Segoe UI' !important; color:black !important; font-weight:bold; font-size: 0.6rem;"
    *ngIf="!!arrayVenta.idVenta && idComprobante==1 " id="recibo">
    <p class="text-uppercase line-height-1 text-xs">
        {{arrayVenta.idEmpleadoProveedorNavigation.idProveedorNavigation.razonSocial}} <br>
        NIT: {{arrayVenta.idEmpleadoProveedorNavigation.idProveedorNavigation.nit}} <br>
        {{arrayVenta.idTiendaNavigation.nombreTienda}}<br>
        {{arrayVenta.idTiendaNavigation.direccion}}<br>
        {{arrayVenta.idTiendaNavigation.telefono}}
    </p>
    <hr>
    <p class="text-uppercase line-height-1 text-xs">{{title}} NRO. {{arrayVenta.idVenta}} <br>
        Documento: {{arrayVenta.prefijo}} - {{arrayVenta.numeracion}} <br>
        Fecha : {{arrayVenta.fechaRegistro | date: "yyyy-MM-dd hh:mm a"}} <br>
        Cajero : {{arrayVenta.idEmpleadoProveedorNavigation.idEmpleadoNavigation.nombres}}&nbsp;
        {{arrayVenta.idEmpleadoProveedorNavigation.idEmpleadoNavigation.apellidos}}<br>
        Vendedor: {{arrayVenta.idEmpleadoProveedorVentaNavigation.idEmpleadoNavigation.nombres.trim()}}&nbsp;
        {{arrayVenta.idEmpleadoProveedorVentaNavigation.idEmpleadoNavigation.apellidos.trim()}}
    </p>
    <hr>
    <p class="text-uppercase  line-height-1 text-xs">
        Cliente : {{(arrayVenta.idClienteNavigation.razonSocial??"NA")
        !="NA"?(arrayVenta.idClienteNavigation.razonSocial??"").toUpperCase()
        :(arrayVenta.idClienteNavigation.nombres??"").toUpperCase()}} <br>
        Identificación : {{arrayVenta.idClienteNavigation.identificacion??""}}<br>
        Email : {{arrayVenta.idClienteNavigation.email??"".toLowerCase()}}<br>
        Teléfono : {{arrayVenta.idClienteNavigation.telefono??""}}
    </p>
    <div class="flex flex-wrap justify-content-between pl-2 pr-2">
        <div class="w-1 p-0 text-center">CANT</div>
        <div class="w-4 p-0 text-center">DESCR</div>
        <div class="w-3 p-0 text-right">PRECIO</div>
        <!-- <div class="col-2 text-center">IMP</div> -->
        <div class="w-4 p-0 text-right">TOTAL</div>
    </div>
    <hr>
    <div *ngFor="let row of arrayVenta.detalleVenta">
        <div class="flex flex-wrap justify-content-between pl-2 pr-2">
            <div class="w-1 text-center">{{row.cantidad}}</div>
            <div class="w-4 text-center line-height-1">
                {{row.idProductoNavigation.descripcionCorta}}- {{row.idProductoNavigation.referencia}}</div>
            <div class="w-3 text-right">{{(row.subtotal / row.cantidad) | currency : 'USD' : 'symbol' : '1.0-0' }}
            </div>
            <!-- <div class="col-2 text-center">{{row.impuesto | currency}}</div> -->
            <div class="w-4 text-right">{{row.subtotal + row.impuesto | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
        </div>
    </div>
    <hr>
    <div class="flex flex-wrap justify-content-between pl-2 pr-2">
        <div>TOTAL</div>
        <div>{{arrayVenta.detalleVenta.length}}&nbsp;Items</div>
        <div>{{(subtotal + impuesto) | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
    </div>
    <hr>
    <div class="flex flex-wrap  pl-2 pr-2">
        <div class="w-6 text-left">VENTA</div>
        <div class="w-6 text-right">{{(subtotal + descuento) | currency : 'USD' : 'symbol' : '1.0-0'}}
        </div>
        <div class="w-6 text-left">DESCUENTO (-)</div>
        <div class="w-6 text-right">{{(descuento) | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
        <div class="w-6 text-left">SUBTOTAL</div>
        <div class="w-6 text-right">{{(subtotal) | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
        <div class="w-6 text-left">IMPUESTO</div>
        <div class="w-6 text-right">{{(impuesto) | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
        <div class="w-6 text-left">TOTAL A PAGAR</div>
        <div class="w-6 text-right">{{(subtotal + impuesto) | currency : 'USD' : 'symbol' : '1.0-0'}}
        </div>
    </div>
    <hr>
    <p class="text-uppercase">Metodo de pago</p>
    <div class="flex flex-wrap pl-2 pr-2" *ngFor="let item of arrayVenta.ventaPagos">
        <div class="w-3 text-left puntosText">{{item.idVentaMetodoPagoNavigation.metodoPago}}</div>
        <div class="w-5 text-center">{{item.referencia=='Efectivo' ?'': 'REF: ' + item.referencia}}</div>
        <div class="w-4 text-right">{{(item.valor == 0 ? subtotal + impuesto : item.valor) |
            currency : 'USD' : 'symbol' : '1.0-0'}}</div>
    </div>
    <hr>
    <p class="text-uppercase line-height-1">Discriminación de Impuestos</p>
    <div class="flex flex-wrap pl-2 pr-2 justify-content-between">
        <div class="w-1">TIPO</div>
        <div class="w-4 text-right">BASE</div>
        <div class="w-3 text-right">IMP</div>
        <div class="w-4 text-right">VENTA</div>
    </div>
    <div class="flex flex-wrap pl-2 pr-2" *ngFor="let item of discImpuesto">
        <div class="w-1 text-center">{{item.Tipo}}%</div>
        <div class="w-4 text-right">{{item.Base | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
        <div class="w-3 text-right">{{item.Impuesto | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
        <div class="w-4 text-right">{{item.Venta | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
    </div>
    <hr>
    <p class=" line-height-1"><span
            [innerHtml]="arrayVenta.idTiendaNavigation.idResolucionNavigation.descripcion"></span>
    </p>
    <p class="text-center  line-height-1">
        <span [innerHtml]="arrayVenta.idTiendaNavigation.idResolucionNavigation.mensajeFin"></span>
    </p>

</div>
<!--Recibo nro 2-->
<div media="print" class="{{setImpresion ? '':'noView'}} text-center mx-auto"
    style="max-width:302px; font-family: 'Segoe UI' !important; color:black !important; font-weight:bold"
    *ngIf="!!arrayVenta.idVenta && idComprobante==2" id="recibo">
    <p class="text-uppercase  line-height-1">
        {{arrayVenta.idEmpleadoProveedorNavigation.idProveedorNavigation.razonSocial}} <br>
        NIT: {{arrayVenta.idEmpleadoProveedorNavigation.idProveedorNavigation.nit}} <br>
        {{arrayVenta.idTiendaNavigation.nombreTienda}}<br>
        {{arrayVenta.idTiendaNavigation.direccion}}<br>
        {{arrayVenta.idTiendaNavigation.telefono}}
    </p>
    <hr>
    <p class="text-uppercase  line-height-1">{{title}} NRO. {{arrayVenta.idVenta}} <br>
        Doc. Equivalente POS: {{arrayVenta.prefijo}} - {{arrayVenta.numeracion}} <br>
        Fecha : {{arrayVenta.fechaRegistro | date: "yyyy-MM-dd hh:mm a"}} <br>
        Cajero : {{arrayVenta.idEmpleadoProveedorNavigation.idEmpleadoNavigation.nombres}}&nbsp;
        {{arrayVenta.idEmpleadoProveedorNavigation.idEmpleadoNavigation.apellidos}}<br>
        Vendedor: {{arrayVenta.idEmpleadoProveedorVentaNavigation.idEmpleadoNavigation.nombres.trim()}}&nbsp;
        {{arrayVenta.idEmpleadoProveedorVentaNavigation.idEmpleadoNavigation.apellidos.trim()}}
    </p>
    <hr>
    <p class="text-uppercase  line-height-1">
        Cliente : {{(arrayVenta.idClienteNavigation?.nombres??"").toUpperCase()}} <br>
        Identificación : {{arrayVenta.idClienteNavigation?.identificacion??""}}<br>
        Email : {{arrayVenta.idClienteNavigation?.email??"".toLowerCase()}}<br>
        Teléfono : {{arrayVenta.idClienteNavigation?.telefono??""}}
    </p>
    <hr>
    <div class="grid ">
        <div class="col-1 p-0 text-center">CANT</div>
        <div class="col-4 p-0 text-center">DESCR</div>
        <div class="col-3 p-0 text-center">PRECIO</div>
        <!-- <div class="col-2 text-center">IMP</div> -->
        <div class="col-4 p-0 text-center">TOTAL</div>
    </div>
    <hr>
    <div class="" *ngFor="let row of arrayVenta.detalleVenta">
        <div class="grid">
            <div class="col-1 text-center">{{row.cantidad}}</div>
            <div class="col-4 text-center line-height-1">
                {{row.idProductoNavigation.descripcionCorta}}- {{row.idProductoNavigation.referencia}}</div>
            <div class="col-3 text-center">{{(row.subtotal / row.cantidad) | currency : 'USD' : 'symbol' : '1.0-0' }}
            </div>
            <!-- <div class="col-2 text-center">{{row.impuesto | currency}}</div> -->
            <div class="col-4 text-center">{{row.subtotal + row.impuesto | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
        </div>
    </div>
    <hr>
    <div class="grid ">
        <div class="col-2 text-left">TOTAL</div>
        <div class="col-4 text-right">{{arrayVenta.detalleVenta.length}}&nbsp;Items</div>
        <div class="col-6 text-right">{{(subtotal + impuesto) | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
    </div>
    <hr>
    <div class="grid  pl-2 pr-2">
        <div class="col-6 text-left lineHeight6">VENTA</div>
        <div class="col-6 text-right lineHeight6">{{(subtotal + descuento) | currency : 'USD' : 'symbol' : '1.0-0'}}
        </div>
        <div class="col-6 text-left lineHeight6">DESCUENTO (-)</div>
        <div class="col-6 text-right lineHeight6">{{(descuento) | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
        <div class="col-6 text-left lineHeight6">SUBTOTAL</div>
        <div class="col-6 text-right lineHeight6">{{(subtotal) | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
        <div class="col-6 text-left lineHeight6">IMPUESTO</div>
        <div class="col-6 text-right lineHeight6">{{(impuesto) | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
        <div class="col-6 text-left lineHeight6">TOTAL A PAGAR</div>
        <div class="col-6 text-right lineHeight6">{{(subtotal + impuesto) | currency : 'USD' : 'symbol' : '1.0-0'}}
        </div>
    </div>
    <hr>
    <p class="text-uppercase line-height-1">Metodo de pago</p>
    <div class="grid " *ngFor="let item of arrayVenta.ventaPagos">
        <div class="col-3 text-left lineHeight6 puntosText">{{item.idVentaMetodoPagoNavigation.metodoPago}}</div>
        <div class="col-5 text-center lineHeight6">{{item.referencia=='Efectivo' ?'': 'REF: ' + item.referencia}}</div>
        <div class="col-4 text-right lineHeight6">{{(item.valor == 0 ? subtotal + impuesto : item.valor) |
            currency : 'USD' : 'symbol' : '1.0-0'}}</div>
    </div>
    <hr>
    <p class=" line-height-1"><span
            [innerHtml]="arrayVenta.idTiendaNavigation.idResolucionNavigation.descripcion"></span>
    </p>
    <p class="text-center  line-height-1">
        <span [innerHtml]="arrayVenta.idTiendaNavigation.idResolucionNavigation.mensajeFin"></span>
    </p>
    <div class="text-center">
        <!-- <ngx-barcode [bc-value]="arrayVenta.idVenta" [bc-display-value]="false" [bc-height]="30"></ngx-barcode> -->
    </div>
</div>
<!-- Recibo Nro. 3 FE -->
<div media="print" class="{{setImpresion ? '':'noView'}} text-center mx-auto"
    style="max-width:302px; font-family: 'Segoe UI' !important; color:black !important; font-weight:bold; font-size:0.7em"
    *ngIf="!!arrayVenta.idVenta && idComprobante==3" id="recibo">
    <p class="text-uppercase  line-height-1">
        {{arrayVenta.idEmpleadoProveedorNavigation.idProveedorNavigation.razonSocial}} <br>
        NIT: {{arrayVenta.idEmpleadoProveedorNavigation.idProveedorNavigation.nit}} <br>
        {{arrayVenta.idTiendaNavigation.nombreTienda}}<br>
        {{arrayVenta.idTiendaNavigation.direccion}}<br>
        {{arrayVenta.idTiendaNavigation.telefono}}
    </p>
    <hr>
    <p class="text-uppercase  line-height-1">{{title}} NRO. {{arrayVenta.idVenta}} <br>
        Doc. Equivalente POS: {{arrayVenta.prefijo}} - {{arrayVenta.numeracion}} <br>
        Fecha : {{arrayVenta.fechaRegistro | date: "yyyy-MM-dd hh:mm a"}} <br>
        Cajero : {{arrayVenta.idEmpleadoProveedorNavigation.idEmpleadoNavigation.nombres}}&nbsp;
        {{arrayVenta.idEmpleadoProveedorNavigation.idEmpleadoNavigation.apellidos}}<br>
        Vendedor: {{arrayVenta.idEmpleadoProveedorVentaNavigation.idEmpleadoNavigation.nombres.trim()}}&nbsp;
        {{arrayVenta.idEmpleadoProveedorVentaNavigation.idEmpleadoNavigation.apellidos.trim()}}
    </p>
    <hr>
    <p class="text-uppercase  line-height-1">
        Cliente : {{(arrayVenta.idClienteNavigation?.nombres??"").toUpperCase()}} <br>
        Identificación : {{arrayVenta.idClienteNavigation?.identificacion??""}}<br>
        Email : {{arrayVenta.idClienteNavigation?.email??"".toLowerCase()}}<br>
        Teléfono : {{arrayVenta.idClienteNavigation?.telefono??""}}
    </p>
    <hr>
    <div class="grid  pl-2 pr-2">
        <div class="col-2 text-left">TOTAL</div>
        <div class="col-4 text-right">{{arrayVenta.detalleVenta.length}}&nbsp;Items</div>
        <div class="col-6 text-right">{{(subtotal + impuesto) | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
    </div>
    <div class="grid  pl-2 pr-2">
        <div class="col-6 text-left lineHeight6">VENTA</div>
        <div class="col-6 text-right lineHeight6">{{(subtotal + descuento) | currency : 'USD' : 'symbol' : '1.0-0'}}
        </div>
        <div class="col-6 text-left lineHeight6">DESCUENTO (-)</div>
        <div class="col-6 text-right lineHeight6">{{(descuento) | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
        <div class="col-6 text-left lineHeight6">SUBTOTAL</div>
        <div class="col-6 text-right lineHeight6">{{(subtotal) | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
        <div class="col-6 text-left lineHeight6">IMPUESTO</div>
        <div class="col-6 text-right lineHeight6">{{(impuesto) | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
        <div class="col-6 text-left lineHeight6">TOTAL A PAGAR</div>
        <div class="col-6 text-right lineHeight6">{{(subtotal + impuesto) | currency : 'USD' : 'symbol' : '1.0-0'}}
        </div>
    </div>
    <hr>
    <p class="text-uppercase line-height-1">Metodo de pago</p>
    <div class="grid " *ngFor="let item of arrayVenta.ventaPagos">
        <div class="col-3 text-left lineHeight6 puntosText">{{item.idVentaMetodoPagoNavigation.metodoPago}}</div>
        <div class="col-5 text-center lineHeight6">{{item.referencia=='Efectivo' ?'': 'REF: ' + item.referencia}}</div>
        <div class="col-4 text-right lineHeight6">{{(item.valor == 0 ? subtotal + impuesto : item.valor) |
            currency : 'USD' : 'symbol' : '1.0-0'}}</div>
    </div>
    <br>
    <p class=" line-height-1 uppercase">Este documento no es valido como factura.<br>
        Escanee este código QR para descargar su factura.
    </p>
    <qr-code value="{{config.urlHome + 'FE/'+ encriptar(arrayVenta.idVenta)}}" size="120" errorCorrectionLevel="M" />
    <p class="text-center  line-height-1">
        <span [innerHtml]="arrayVenta.idTiendaNavigation.idResolucionNavigation.mensajeFin"></span>
    </p>
</div>